export default __webpack_public_path__ + "static/home_banner_2-home-2754649200b560d902cb8357c6c9c5ba.png";